const { registerBlockType } = wp.blocks;

import Editor from "./Editor";
import Save from "./Save";

registerBlockType('custom-form/block', {
  title: 'Formulário customizado',
  description: 'Formulário customizável que pode receber vários campos únicos para ele',
  icon: 'forms',
  category: 'widgets',
  attributes: {
    showTitle: {
      type: 'boolean',
      default: false
    },
    showSubtitle: {
      type: 'boolean',
      default: false
    },
    title: {
      type: 'string',
    },
    subtitle: {
      type: 'string',
    },
    formId: {
      type: 'string'
    },
  },

  edit: props => <Editor {...props} />,
  save: props => <Save {...props} />
});
